const BASE_URL = 'https://office.mavistech.uk';
//const BASE_URL = 'http://127.0.0.1:8000';
export default BASE_URL;